module.exports = __webpack_public_path__ + "2b51e126cfafcf39af6aa5340891a4ec.png";